// GENERATED FILE. DO NOT EDIT!
// GENERATOR       de.ebootis.sfx.sfxGen.TypescriptGen

import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { Tlob, ISfxServiceInvoker, SFX_SERVICE_INVOKER } from '@ebootis/common';
import { ZbsCampaignMode } from '../Ebootis.Shared/ZbsCampaignMode';

@Injectable({
	providedIn: 'root'
})

export class IZbsApp {

	readonly REMOTE_NAME: string = 'zbs';

	constructor(@Inject(SFX_SERVICE_INVOKER) private sfxService: ISfxServiceInvoker) {
	}

	addCampaignCol(campaignOid: string, campaignCol: IZbsApp.ZbsCampaignCol): Observable<IZbsApp.ZbsCampaignCol> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (campaignCol != null) { params.campaignCol = campaignCol; }

		return this.sfxService.post<IZbsApp.ZbsCampaignCol>(this.REMOTE_NAME, "addCampaignCol", params);
	}

	addCampaignCustRows(campaignOid: string, customerOids: string[]): Observable<IZbsApp.ZbsCampaignCustRow[]> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (customerOids != null) { params.customerOids = customerOids; }

		return this.sfxService.post<IZbsApp.ZbsCampaignCustRow[]>(this.REMOTE_NAME, "addCampaignCustRows", params);
	}

	addCampaignRows(campaignOid: string, hierarchyNode: string, logisticsAreaProxyUid: string): Observable<IZbsApp.ZbsCampaignRow[]> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (hierarchyNode != null) { params.hierarchyNode = hierarchyNode; }
		if (logisticsAreaProxyUid != null) { params.logisticsAreaProxyUid = logisticsAreaProxyUid; }

		return this.sfxService.post<IZbsApp.ZbsCampaignRow[]>(this.REMOTE_NAME, "addCampaignRows", params);
	}

	authorizeOrder(parms: IZbsApp.AuthorizeOrderParms): Observable<string> {
		let params: any = {};
		if (parms != null) { params.parms = parms; }

		return this.sfxService.post<string>(this.REMOTE_NAME, "authorizeOrder", params);
	}

	canUserOrder(): Observable<Date> {
		return this.sfxService.get<Date>(this.REMOTE_NAME, "canUserOrder");
	}

	createBudget(userProxyOid: string, yearFrom: number, budget: number): Observable<string> {
		let params: any = {};
		if (userProxyOid != null) { params.userProxyOid = userProxyOid; }
		if (yearFrom != null) { params.yearFrom = yearFrom.toString(); }
		if (budget != null) { params.budget = budget.toString(); }

		return this.sfxService.post<string>(this.REMOTE_NAME, "createBudget", params);
	}

	createCampaingOrder(zbsConfigOid: string, campaignOid: string, custRowOid: string): Observable<string> {
		let params: any = {};
		if (zbsConfigOid != null) { params.zbsConfigOid = zbsConfigOid; }
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (custRowOid != null) { params.custRowOid = custRowOid; }

		return this.sfxService.post<string>(this.REMOTE_NAME, "createCampaingOrder", params);
	}

	createCampaingOrders(zbsConfigOid: string, campaignOid: string, custRowOids: string[]): Observable<{}> {
		let params: any = {};
		if (zbsConfigOid != null) { params.zbsConfigOid = zbsConfigOid; }
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (custRowOids != null) { params.custRowOids = custRowOids; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "createCampaingOrders", params);
	}

	deleteCampaignOrder(campaignOid: string, customerOid: string): Observable<{}> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (customerOid != null) { params.customerOid = customerOid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "deleteCampaignOrder", params);
	}

	finishCampaign(campaignOid: string): Observable<{}> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "finishCampaign", params);
	}

	getArticleContingent(zbsConfigOid: string, articleOid: string, targetUnit: string): Observable<IZbsApp.ArticleContingent> {
		let params = new HttpParams();
		if (zbsConfigOid != null) { params = params.set('zbsConfigOid',zbsConfigOid); }
		if (articleOid != null) { params = params.set('articleOid',articleOid); }
		if (targetUnit != null) { params = params.set('targetUnit',targetUnit); }

		return this.sfxService.get<IZbsApp.ArticleContingent>(this.REMOTE_NAME, "getArticleContingent", params);
	}

	getBudgetByUserProxyYear(userProxyOid: string, year: number): Observable<IZbsApp.ZbsBudget> {
		let params = new HttpParams();
		if (userProxyOid != null) { params = params.set('userProxyOid',userProxyOid); }
		if (year != null) { params = params.set('year',year.toString()); }

		return this.sfxService.get<IZbsApp.ZbsBudget>(this.REMOTE_NAME, "getBudgetByUserProxyYear", params);
	}

	getBudgetListByUserProxy(userProxyOid: string): Observable<IZbsApp.ZbsBudget[]> {
		let params: any = {};
		if (userProxyOid != null) { params.userProxyOid = userProxyOid; }

		return this.sfxService.post<IZbsApp.ZbsBudget[]>(this.REMOTE_NAME, "getBudgetListByUserProxy", params);
	}

	getCampaign(campaignOid: string): Observable<IZbsApp.ZbsCampaign> {
		let params = new HttpParams();
		if (campaignOid != null) { params = params.set('campaignOid',campaignOid); }

		return this.sfxService.get<IZbsApp.ZbsCampaign>(this.REMOTE_NAME, "getCampaign", params);
	}

	getCampaignCustMatrix(campaignRowOid: string, campaignOid: string): Observable<IZbsApp.ZbsCampaignCustMatrix> {
		let params = new HttpParams();
		if (campaignRowOid != null) { params = params.set('campaignRowOid',campaignRowOid); }
		if (campaignOid != null) { params = params.set('campaignOid',campaignOid); }

		return this.sfxService.get<IZbsApp.ZbsCampaignCustMatrix>(this.REMOTE_NAME, "getCampaignCustMatrix", params);
	}

	getCampaignMatrix(campaignOid: string): Observable<IZbsApp.ZbsCampaignMatrix> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }

		return this.sfxService.post<IZbsApp.ZbsCampaignMatrix>(this.REMOTE_NAME, "getCampaignMatrix", params);
	}

	getCampaigns(onlyOpenCampaigns: boolean, name: string, mode: ZbsCampaignMode, dateFrom: Date, dateUntil: Date): Observable<IZbsApp.ZbsCampaign[]> {
		let params: any = {};
		if (onlyOpenCampaigns != null) { params.onlyOpenCampaigns = onlyOpenCampaigns.toString(); }
		if (name != null) { params.name = name; }
		if (mode != null) { params.mode = mode; }
		if (dateFrom != null) { params.dateFrom = dateFrom.toISOString(); }
		if (dateUntil != null) { params.dateUntil = dateUntil.toISOString(); }

		return this.sfxService.post<IZbsApp.ZbsCampaign[]>(this.REMOTE_NAME, "getCampaigns", params);
	}

	getCityForZipCode(countryCode: string, zipCode: string): Observable<IZbsApp.CityForZipCodeResult> {
		let params = new HttpParams();
		if (countryCode != null) { params = params.set('countryCode',countryCode); }
		if (zipCode != null) { params = params.set('zipCode',zipCode); }

		return this.sfxService.get<IZbsApp.CityForZipCodeResult>(this.REMOTE_NAME, "getCityForZipCode", params);
	}

	getClsArticleAuthorization(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsArticleAuthorization");
	}

	getClsClassOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsClassOid");
	}

	getClsCostcenterOid1(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsCostcenterOid1");
	}

	getClsCostcenterOid2(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsCostcenterOid2");
	}

	getClsIBANOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsIBANOid");
	}

	getClsSWIFTOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsSWIFTOid");
	}

	getClsUseInZbsOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsUseInZbsOid");
	}

	getClsUserOrderOffset(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsUserOrderOffset");
	}

	getClsVerificationCodeOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getClsVerificationCodeOid");
	}

	getComChannelRoleOidForPO(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getComChannelRoleOidForPO");
	}

	getCompanyEmployees(configOid: string): Observable<IZbsApp.Employee[]> {
		let params = new HttpParams();
		if (configOid != null) { params = params.set('configOid',configOid); }

		return this.sfxService.get<IZbsApp.Employee[]>(this.REMOTE_NAME, "getCompanyEmployees", params);
	}

	getCustomerInfoTextClassificationProxyOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getCustomerInfoTextClassificationProxyOid");
	}

	getEmployeeAuthorizationRoleOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getEmployeeAuthorizationRoleOid");
	}

	getEmployeeRoleOidBudgetAdmin(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getEmployeeRoleOidBudgetAdmin");
	}

	getEmployeesBySearchParms(configOid: string, login: string, firstname: string, lastname: string, street: string, zip: string, city: string, desc: string, budgetMin: number, budgetMax: number): Observable<IZbsApp.Employee[]> {
		let params = new HttpParams();
		if (configOid != null) { params = params.set('configOid',configOid); }
		if (login != null) { params = params.set('login',login); }
		if (firstname != null) { params = params.set('firstname',firstname); }
		if (lastname != null) { params = params.set('lastname',lastname); }
		if (street != null) { params = params.set('street',street); }
		if (zip != null) { params = params.set('zip',zip); }
		if (city != null) { params = params.set('city',city); }
		if (desc != null) { params = params.set('desc',desc); }
		if (budgetMin != null) { params = params.set('budgetMin',budgetMin.toString()); }
		if (budgetMax != null) { params = params.set('budgetMax',budgetMax.toString()); }

		return this.sfxService.get<IZbsApp.Employee[]>(this.REMOTE_NAME, "getEmployeesBySearchParms", params);
	}

	getInfoTextClassificationProxyOid(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getInfoTextClassificationProxyOid");
	}

	getOrderValueWithoutFreightage(order: IZbsApp.Order): Observable<number> {
		let params: any = {};
		if (order != null) { params.order = order; }

		return this.sfxService.post<number>(this.REMOTE_NAME, "getOrderValueWithoutFreightage", params);
	}

	getPaymentMethodProxyOidForBudget(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getPaymentMethodProxyOidForBudget");
	}

	getPaymentMethodProxyOidForPO(): Observable<string> {
		return this.sfxService.get<string>(this.REMOTE_NAME, "getPaymentMethodProxyOidForPO");
	}

	getUsedBudget(): Observable<IZbsApp.UsedBudget> {
		return this.sfxService.get<IZbsApp.UsedBudget>(this.REMOTE_NAME, "getUsedBudget");
	}

	removeBudget(budgetUid: string): Observable<{}> {
		let params: any = {};
		if (budgetUid != null) { params.budgetUid = budgetUid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "removeBudget", params);
	}

	removeCampaign(campaignOid: string): Observable<{}> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "removeCampaign", params);
	}

	removeCampaignCol(campaignColOid: string): Observable<{}> {
		let params: any = {};
		if (campaignColOid != null) { params.campaignColOid = campaignColOid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "removeCampaignCol", params);
	}

	removeCampaignCustRows(campaignOid: string, custRowOids: string[]): Observable<{}> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (custRowOids != null) { params.custRowOids = custRowOids; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "removeCampaignCustRows", params);
	}

	removeCampaignRow(campaignRowOid: string): Observable<{}> {
		let params: any = {};
		if (campaignRowOid != null) { params.campaignRowOid = campaignRowOid; }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "removeCampaignRow", params);
	}

	removeCustomer(customerOid: string, zbsConfigOid: string): Observable<boolean> {
		let params: any = {};
		if (customerOid != null) { params.customerOid = customerOid; }
		if (zbsConfigOid != null) { params.zbsConfigOid = zbsConfigOid; }

		return this.sfxService.post<boolean>(this.REMOTE_NAME, "removeCustomer", params);
	}

	saveBudget(budgetUid: string, yearFrom: number, budget: number): Observable<{}> {
		let params: any = {};
		if (budgetUid != null) { params.budgetUid = budgetUid; }
		if (yearFrom != null) { params.yearFrom = yearFrom.toString(); }
		if (budget != null) { params.budget = budget.toString(); }

		return this.sfxService.post<{}>(this.REMOTE_NAME, "saveBudget", params);
	}

	saveCampaign(campaign: IZbsApp.ZbsCampaign): Observable<IZbsApp.ZbsCampaign> {
		let params: any = {};
		if (campaign != null) { params.campaign = campaign; }

		return this.sfxService.post<IZbsApp.ZbsCampaign>(this.REMOTE_NAME, "saveCampaign", params);
	}

	saveCampaignCustMatrix(campaignOid: string, campaignRowOid: string, cols: IZbsApp.ZbsCampaignCol[], cells: IZbsApp.ZbsCampaignCustCell[], rows: IZbsApp.ZbsCampaignCustRowDeliveryDate[]): Observable<IZbsApp.SaveCustMatrixResult> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (campaignRowOid != null) { params.campaignRowOid = campaignRowOid; }
		if (cols != null) { params.cols = cols; }
		if (cells != null) { params.cells = cells; }
		if (rows != null) { params.rows = rows; }

		return this.sfxService.post<IZbsApp.SaveCustMatrixResult>(this.REMOTE_NAME, "saveCampaignCustMatrix", params);
	}

	saveCampaignMatrix(campaignOid: string, cols: IZbsApp.ZbsCampaignCol[], cells: IZbsApp.ZbsCampaignCell[]): Observable<IZbsApp.SaveMatrixResult> {
		let params: any = {};
		if (campaignOid != null) { params.campaignOid = campaignOid; }
		if (cols != null) { params.cols = cols; }
		if (cells != null) { params.cells = cells; }

		return this.sfxService.post<IZbsApp.SaveMatrixResult>(this.REMOTE_NAME, "saveCampaignMatrix", params);
	}

	saveCustomer(customer: IZbsApp.Customer, zbsConfigOid: string): Observable<string> {
		let params: any = {};
		if (customer != null) { params.customer = customer; }
		if (zbsConfigOid != null) { params.zbsConfigOid = zbsConfigOid; }

		return this.sfxService.post<string>(this.REMOTE_NAME, "saveCustomer", params);
	}

	saveOrder(order: IZbsApp.Order): Observable<string> {
		let params: any = {};
		if (order != null) { params.order = order; }

		return this.sfxService.post<string>(this.REMOTE_NAME, "saveOrder", params);
	}

	simulateOrder(order: IZbsApp.Order): Observable<IZbsApp.SimulatedOrder> {
		let params: any = {};
		if (order != null) { params.order = order; }

		return this.sfxService.post<IZbsApp.SimulatedOrder>(this.REMOTE_NAME, "simulateOrder", params);
	}

}
export namespace IZbsApp {

	export const SERVICE_NAME = "zbs";

	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$Address")
	export class Address {
		userAddressOid: string;
		zbsCustomerOid: string;
		name: string;
		country: string;
		city: string;
		zip: string;
		street: string;
		email: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ArticleContingent")
	export class ArticleContingent {
		contingent: number;
		usedContingent: number;
		unitOid: string;
		unitName: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$AuthorizeOrderItem")
	export class AuthorizeOrderItem {
		itemOid: string;
		amount: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$AuthorizeOrderParms")
	export class AuthorizeOrderParms {
		orderOid: string;
		items: IZbsApp.AuthorizeOrderItem[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$CityForZipCodeResult")
	export class CityForZipCodeResult {
		retCode: number;
		cities: string[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$Customer")
	export class Customer {
		oid: string;
		id: string;
		isManualAdr: boolean;
		isPublicAdr: boolean;
		companyName1: string;
		companyName2: string;
		title: string;
		firstName: string;
		lastName: string;
		companyOid: string;
		userProxyOid: string;
		hierarchyNode1: string;
		hierarchyNode2: string;
		hierarchyNode3: string;
		hierarchyNode4: string;
		phoneNumber: string;
		email: string;
		logisticsAreaProxyOid: string;
		country: string;
		city: string;
		zip: string;
		street: string;
		distributionAmount1: number;
		distributionAmount2: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$Employee")
	export class Employee {
		oid: string;
		userProxyOid: string;
		id: string;
		login: string;
		title: string;
		firstName: string;
		lastName: string;
		street: string;
		desc: string;
		zip: string;
		city: string;
		budget: IZbsApp.ZbsBudget;
		usedBudget: IZbsApp.UsedBudget;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$Order")
	export class Order {
		zbsConfigOid: string;
		infoText: string;
		customerInfoText: string;
		dispatchDefinitionOid: string;
		deliveryDate: Date;
		costCenter1: string;
		costCenter2: string;
		paymentMethodProxyOid: string;
		poId: string;
		verificationCode: string;
		deliveryAddress: IZbsApp.Address;
		invoiceCreation: boolean;
		isLockedForDelivery: boolean;
		invoiceAddress: IZbsApp.Address;
		items: IZbsApp.OrderItem[];
		zbsValuelistEntryOid: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$OrderItem")
	export class OrderItem {
		qtty: number;
		unitOid: string;
		articleOid: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$SaveCustMatrixResult")
	export class SaveCustMatrixResult {
		colErrs: IZbsApp.ZbsError[];
		cellErrs: IZbsApp.ZbsError[];
		custCellErrs: IZbsApp.ZbsError[];
		custRowErrs: IZbsApp.ZbsError[];
		newCells: IZbsApp.ZbsCampaignCustCell[];
		removedCells: string[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$SaveMatrixResult")
	export class SaveMatrixResult {
		colErrs: IZbsApp.ZbsError[];
		cellErrs: IZbsApp.ZbsError[];
		newCells: IZbsApp.ZbsCampaignCell[];
		removedCells: string[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$SimulatedOrder")
	export class SimulatedOrder {
		orderValue: number;
		freightageSurcharge: number;
		budget: IZbsApp.UsedBudget;
		budgetError: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$UsedBudget")
	export class UsedBudget {
		budget: number;
		usedBudget: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsBudget")
	export class ZbsBudget {
		oid: string;
		userProxyOid: string;
		yearFrom: number;
		budget: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaign")
	export class ZbsCampaign {
		oid: string;
		name: string;
		id: string;
		adminUserProxyOid: string;
		hierarchyLevel: number;
		mode: ZbsCampaignMode;
		zbsConfigOid: string;
		finishedByUser: string;
		creationDate: Date;
		removeAble: boolean;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCell")
	export class ZbsCampaignCell {
		oid: string;
		rowOid: string;
		colOid: string;
		planAmount: number;
		sumReservedAmount: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCol")
	export class ZbsCampaignCol {
		oid: string;
		articleProxyOid: string;
		amount: number;
		sumPlanAmount: number;
		sumReservedAmount: number;
		ordinal: number;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCustCell")
	export class ZbsCampaignCustCell {
		oid: string;
		colOid: string;
		cellOid: string;
		customerOid: string;
		reservedAmount: number;
		adminOnly: boolean;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCustMatrix")
	export class ZbsCampaignCustMatrix {
		rows: IZbsApp.ZbsCampaignCustRow[];
		cells: IZbsApp.ZbsCampaignCustCell[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCustRow")
	export class ZbsCampaignCustRow {
		oid: string;
		customerOid: string;
		name: string;
		sortName: string;
		zip: string;
		city: string;
		distAmount1: number;
		distAmount2: number;
		orderOid: string;
		isOrderDeletable: boolean;
		deliveryDate: Date;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignCustRowDeliveryDate")
	export class ZbsCampaignCustRowDeliveryDate {
		customerOid: string;
		deliveryDate: Date;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignMatrix")
	export class ZbsCampaignMatrix {
		cols: IZbsApp.ZbsCampaignCol[];
		rows: IZbsApp.ZbsCampaignRow[];
		cells: IZbsApp.ZbsCampaignCell[];
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsCampaignRow")
	export class ZbsCampaignRow {
		oid: string;
		hierarchyNode: string;
		logisticsAreaProxyOid: string;
		lapDisplayName: string;
		lapDescr: string;
	}
	//TypeDesc("de.ebootis.fet.customerSpecific.cs0406.services.zbs.IZbsApp$ZbsError")
	export class ZbsError {
		oid: string;
		error: string;
	}
}
